import { Snackbar } from '@mui/material';

interface Props {
  message: string;
  onClose: () => void;
}

export const AlertSnackbar: React.FC<Props> = ({ message, onClose }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={true}
      onClose={onClose}
      message={message}
      autoHideDuration={3000}
    />
  );
};
